import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M8.895 5.565h3.264l2.884 2.884-.816 4.08 4.46 4.458-1.633 1.632-4.46-4.458-4.078.815-2.884-2.884V8.828l3.642 3.643 2.72-.545.543-2.719-3.642-3.642z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);
